export class ChartLayerPoint {
    x: number;
    y: number;
    constructor(pointData: any) {
        pointData = (pointData || {});
        this.x = pointData.x;
        this.y = pointData.y;
    }
}
